import * as THREE from "three";
import { Emitter, IEmitter3DConfig } from "./emitter.js";

export class PayloadEmitter<T> extends Emitter
{
  private readonly _payload: T;

  public get payload(): T
  {
    return this._payload;
  }

  constructor( position: THREE.Vector3, payload: T, config?: IEmitter3DConfig )
  {
    super( position, config );
    this._payload = payload;
  }
}
